import './loading-spinner.scss'

const LoadingSpinner = ({ size = '' }) => {
  return (
    <div className={`loading-spinner ${size}`}>
      <span className="loader"></span>
    </div>
  )
}

export default LoadingSpinner
